import React from 'react';
import { Heading } from '../../components';
import { richText } from '../../util/richText';
import renderMarkdown from '../PageBuilder/markdownProcessor';

import css from './ListingPage.module.css';

const MIN_LENGTH_FOR_LONG_WORDS = 20;

const SectionTextMaybe = props => {
  const { text, heading, showAsIngress = false } = props;
  const textClass = showAsIngress ? css.ingress : css.text;
  
  // Check if the text contains markdown syntax
  const hasMarkdown = text && /[#*_`]/.test(text);
  
  // Use markdown processor if markdown syntax is detected, otherwise use richText
  const content = hasMarkdown
    ? renderMarkdown(text, {
        p: ({ children }) => <p className={textClass}>{children}</p>,
        a: ({ href, children }) => (
          <a href={href} target="_blank" rel="noopener noreferrer" className={css.link}>
            {children}
          </a>
        ),
      })
    : richText(text, {
        linkify: true,
        longWordMinLength: MIN_LENGTH_FOR_LONG_WORDS,
        longWordClass: css.longWord,
        breakChars: '/',
      });

  return text ? (
    <section className={css.sectionText}>
      {heading ? (
        <Heading as="h2" rootClassName={css.sectionHeading}>
          {heading}
        </Heading>
      ) : null}
      {hasMarkdown ? content : <p className={textClass}>{content}</p>}
    </section>
  ) : null;
};

export default SectionTextMaybe;
